var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vimeoData !== undefined && _vm.vimeoData !== null)?_c('img',{staticClass:"main-image",attrs:{"src":_vm.vimeoThumb,"alt":_vm.vimeoData.title},on:{"click":_vm.videoModal}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }